import { gql } from '@apollo/client';
import MASTERCODE_FRAGMENT from './mastercodes';
import ORDER_ITEM_FRAGMENT from './order-item';

const BASE_ORDER_FRAGMENT = gql`
  fragment BaseOrderFragment on Order {
    id
    orderNumber
    ecmsOrderNumber
    itemFulfillmentNumber
    dateOrdered
    cmsCustomerNumber
    crmNumber
    dateFulfilled
  }
`;

const ORDER_FRAGMENT = gql`
  fragment OrderFragment on Order {
    ...BaseOrderFragment
    parentOrder {
      ...BaseOrderFragment
    }
    mastercodes {
      ...MastercodeFragment
    }
    orderItems {
      ...BaseOrderItem
    }
  }
  ${BASE_ORDER_FRAGMENT}
  ${MASTERCODE_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;

export default ORDER_FRAGMENT;
